import { useEffect, useState } from 'react';
import * as API from '../../framework/API/api'
import { ENTITYNAME } from '../../framework/constant/constant';
import moment from 'moment';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { useTranslation } from '../../locale/useTranslation';
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import { utility } from '../../framework/utility/utilityProvider';
import CustomTimeLineView from './CustomGanttView';
import { Loader } from '../../framework/forms/helpercomponents/Loader';


const LinearTimelineView = (props) => {

    const currentYear = (new Date()).getFullYear();
    const currentMonth = (new Date()).getMonth();
    const daysInCurrentMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

    var showTitle = props.showTitle ?? true;
    var myTitle = props.title ?? "";
    const lang = useTranslation();

    const [dataItem, setDataItem] = useState({
        StartDate: moment(new Date(currentYear, currentMonth, 1)).format("YYYY-MM-DD"),
        EndDate: moment(new Date(currentYear, currentMonth, daysInCurrentMonth)).format("YYYY-MM-DD"),
        Channel: { SID: 0, FullChannelName: "All" }
    });
    const [data, setData] = useState([]);
    const [channels, setChannels] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        loadcombo();
        // loadData(searchText);
    }, []);

    const loadcombo = async () => {
        var channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });

        console.log(channelRes)
        setChannels([{ SID: 0, FullChannelName: "All" }, ...channelRes.data]);
    }

    const loadData = async (searchValue) => {

        setIsLoading(true);

        var filterPayload = {
            "Channel": dataItem.Channel,
            "StartDate": new Date(dataItem.StartDate).getTime(),
            "EndDate": new Date(dataItem.EndDate).getTime(),
            "SearchText": searchValue
        }

        let res = await API.getLinearPlanning(filterPayload);
        console.log(res)

        if (res.success) {
            setData([...res.data]);
            setIsLoading(false);
        }
    }

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

    const handleServerSideSearch = (e) => {
        setSearchText(() => e.target.value);

        if (e.target.value == '') {
            loadData('');
        }
    };

    const onSearchClick = () => {

        if (searchText != '') {
            loadData(searchText);
        } else {
            loadData('');
        }

    }

    const onSearchEnter = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            onSearchClick();
        }
    }

    const showfilter = () => {
        loadData(searchText);
    }

    const CustomGanttView = (props) => {
        const { timelineViewData = [] } = props;
        
        console.log(timelineViewData)

        if (timelineViewData.length === 0) return null;

        // Convert PublishStartTime and PublishEndTime into Date objects
        const startTimes = timelineViewData.map(item =>
            new Date(utility.convertMilisecondsToDateTimeString(item?.PublishStartDate))
        );
        const endTimes = timelineViewData.map(item =>
            new Date(utility.convertMilisecondsToDateTimeString(item?.PublishEndDate))
        );

        // Calculate min and max
        const startDateTime = new Date(Math.min(...startTimes));
        const endDateTime = new Date(Math.max(...endTimes));

        return (
            <CustomTimeLineView
                startDateTime={startDateTime}
                endDateTime={endDateTime}
                data={timelineViewData}
            />
        );
    };


    

    return (
        <>
            {showTitle && (
                <>
                    <h1 className="page-title txt-color-bludeDark">
                        <i className="fa fa-table marlr" style={{ fontSize: "20px", color: "GrayText" }}></i>
                        <span>{myTitle}</span>
                    </h1>
                </>
            )}
            <div className='row'>
                <div className='col-2'>
                    <label htmlFor="TabView">{lang.channel_label}</label><br />
                    <DropDownList
                        data={channels}
                        name="Channel"
                        textField="FullChannelName"
                        dataItemKey="SID"
                        value={dataItem.Channel}
                        onChange={onChange}
                    />
                </div>
                <div className="col-2">
                    <div className="form-group">
                        <label htmlFor="">{lang.start_date_label}</label>
                        <input type="date" className="form-control form-control-sm" name="StartDate" value={dataItem.StartDate} onChange={onChange} />
                    </div>
                </div>
                <div className="col-2">
                    <div className="form-group">
                        <label htmlFor="">{lang.end_Date_label}</label>
                        <input type="date" className="form-control form-control-sm" name="EndDate" value={dataItem.EndDate} onChange={onChange} />
                    </div>
                </div>
                <div className="col-3 mt-4">
                    <div className='row'>
                        <ActionButton title={lang.show_button_tooltip} name={lang.show_button_text} onClick={showfilter} />
                    </div>
                </div>
                <div className="mt-3 input-group input-group w-300 martb">
                    <input
                        type="text"
                        className="form-control shadow-inset-2 pt-0 pb-0"
                        id="searchInput"
                        aria-label="type 2 or more letters"
                        placeholder={lang.search_button_text}
                        onKeyDown={onSearchEnter}
                        onChange={handleServerSideSearch}
                    />
                    <button id="search" style={{ border: "0px", backgroundColor: "white", height: "40px" }} onClick={onSearchClick}>
                        <div className="input-group-append">
                            <span className="input-group-text">
                                <i style={{ margin: "5px 0px" }} className="fa fa-search" />
                            </span>
                        </div>
                    </button>
                </div>
            </div>
            <div style={{ margin: "0px 10px", textAlign : "right" }}>
                <span className='m-1 p-1' style={{ backgroundColor : "#123458", borderRadius : "5px", color : "white", fontSize : "11px", fontWeight : "450" }}>Unlimited</span>
                <span className='m-1 p-1' style={{ backgroundColor : "#60B5FF" , borderRadius : "5px", color : "white", fontSize : "11px", fontWeight : "450" }}>Limited</span>
            </div>
            {isLoading ? <Loader /> : <CustomGanttView timelineViewData={data} dataItem={dataItem} /> }
        </>
    );
}


export default LinearTimelineView;